// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"142":"ffc8a7f0","618":"236a745e"}[chunkId] + ".chunk.js");